import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const vpsPackagesApi = createApi({
  reducerPath: "vpsPackagesApis",
  baseQuery,
  keepUnusedDataFor: 1,
  tagTypes: ["vps", "vpspackages", "vpsOptions"],
  endpoints: (builder) => ({
    getVpsPackages: builder.query({
      query: () => "vps/packages",
      providesTags: ["vpspackages"],
    }),
    getVpsOptions: builder.query({
      query: (optionId) => `vps/${optionId}/options`,
      providesTags: ["vpsOptions"],
    }),
    vpsHostingRegister: builder.mutation({
      query: (body) => ({
        url: "vps/register",
        method: "POST",
        body,
      }),
      invalidatesTags: ["vps"],
    }),
  }),
});

export const {
  useLazyGetVpsPackagesQuery,
  useVpsHostingRegisterMutation,
  useGetVpsOptionsQuery,
} = vpsPackagesApi;
